import React from "react";
import DynamicSearchInput from "./BaseInputs/DynamicSearchInput";
import util from "../../global/utils/Helpers";

export const keywordSuggestions = async (keyword) => {
  let payload = {
    search: keyword || "*",
    top: 10,
    select: "*",
    suggesterName: "default",
    searchFields: "description, naics_id",
    fuzzy: true,
  };

  return fetch(util.naicsIndex(), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => data)
    .catch((e) => e);
};

const NAICSAdapter = (Component) => {
  let queryObject = {
    label: "NAICS",
    searchAdapter: keywordSuggestions,
    descriptors: {
      _id: "naics_id",
      _title: "description",
    },
  };
  return class Default extends React.Component {
    render() {
      return <Component {...queryObject} {...this.props} />;
    }
  };
};

export default NAICSAdapter(DynamicSearchInput);
